import { fetchApi } from '../settings.js';

export const API_createOrder = async orderData => {
  try {
    const res = await fetchApi('/orders/', {
      method: 'POST',
      body: orderData,
    });
    const order = await res.json();

    // Google Ads conversion tracking
    if (typeof gtag !== 'undefined') {
      gtag('event', 'conversion', {
        send_to: 'AW-992616338', // Replace with your conversion action ID when set up
        value: orderData.totalPrice || 0,
        currency: orderData.currency || 'EUR',
        transaction_id: order.id,
      });
    }

    return order;
  } catch (error) {
    console.error('Error creating order:', error);
    throw error;
  }
};
